<template>
  <div class="slider-range-box">
    <div class="code-box" id="code-box">
      <div class="code-text">
        {{ $translate('pleasePressSlider')+','+$translate('dragRight') }}
      </div>
      <p></p>
      <span class="el-icon-d-arrow-right" style="color: #979797"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SlideRange',
  data() {
    return {
      verification: false,
    }
  },
  mounted() {
    this.moveCode();
  },
  methods: {
    //获取元素距离页面边缘的距离
    // getOffset(box, direction) {
    //   let setDirection = (direction == 'top') ? 'offsetTop' : 'offsetLeft';
    //   let offset = box[setDirection];
    //   let parentBox = box.offsetParent;
    //   while (parentBox) {
    //     offset += parentBox[setDirection];
    //     parentBox = parentBox.offsetParent;
    //   }
    //   parentBox = null;
    //   return parseInt(offset);
    // },
    moveCode() {
      let _this = this;
      let box = document.querySelector("#code-box"),
        progress = box.querySelector("p"),
        evenBox = box.querySelector("span");
      //默认事件
      let boxEven = ['mousedown', 'mousemove', 'mouseup'];
      //改变手机端与pc事件类型
      if (typeof document.ontouchstart == 'object') {
        boxEven = ['touchstart', 'touchmove', 'touchend'];
      }
      let goX, deviation, evenWidth, endX;
      function moveFn(e) {
        e.preventDefault();
        e = (boxEven['0'] == 'touchstart') ? e.touches[0] : e || window.event;
        endX = e.clientX - goX;
        endX = (endX > 0) ? (endX > evenWidth) ? evenWidth : endX : 0;
        if (endX > evenWidth * 0.7) {
          progress.innerText = _this.$translate('loosenValidate');
          progress.style.backgroundColor = "#74CD57";
        } else {
          progress.innerText = '';
          progress.style.backgroundColor = "#FFFF99";
        }
        progress.style.width = endX + deviation + 'px';
        evenBox.style.left = endX + 'px';
      }
      function removeFn() {
        document.removeEventListener(boxEven['2'], removeFn, false);
        document.removeEventListener(boxEven['1'], moveFn, false);
        if (endX > evenWidth * 0.7) {
          progress.innerText = _this.$translate('verifySuccess');
          progress.style.width = evenWidth + deviation + 'px';
          evenBox.style.left = evenWidth + 'px';
          evenBox.onmousedown = null;
          _this.verification = true;
        } else {
          progress.style.width = '0px';
          evenBox.style.left = '0px';
        }
      }
      evenBox.addEventListener(boxEven['0'], function (e) {
        e = (boxEven['0'] == 'touchstart') ? e.touches[0] : e || window.event;
        goX = e.clientX,
          deviation = this.clientWidth,
          evenWidth = box.clientWidth - deviation,
          endX;
        document.addEventListener(boxEven['1'], moveFn, false);
        document.addEventListener(boxEven['2'], removeFn, false);
      }, false);
      return;
    }
  }
}
</script>
<style lang="scss" scoped>
.slider-range-box {
  border: 1px solid #dadada;
  border-radius: 5px;
  .code-box {
    position: relative;
    padding: 0 3px;
    width: 100%;
    height: 36px;
    color: #fff;
    overflow: hidden;
    background: #e8e8e8;
    border: 0;
    border-radius: 5px;
    outline: none;
    p,
    span {
      display: block;
      position: absolute;
      left: 0;
      height: 36px;
      text-align: center;
      line-height: 36px;
      padding: 0;
      margin: 0;
    }
    span {
      width: 36px;
      background-color: #fff;
      font-size: 16px;
      cursor: pointer;
      margin-right: 1px;
    }
    p {
      width: 0;
      background-color: #ffff99;
      overflow: hidden;
      text-indent: -20px;
      transition: background 1s ease-in;
    }
    .code-text {
      position: absolute;
      width: 100%;
      left: 0;
      line-height: 36px;
      color: #757575;
      top: 0;
      font-size: 12px;
      text-align: center;
    }
  }
}
</style>
